import * as yup from "yup";

export const DeletePartnerSchema = yup.object().shape({
  reasonUnsubscribe: yup.string().required("Campo requerido"),
  unsubscribeDate: yup.string().required("Campo requerido"),
  banDate: yup.string().when("temporalUnsubscribe", {
    is: true,
    then: (schema) => schema.required("Campo requerido"),
    otherwise: (schema) => schema.nullable(),
  }),
});
